var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.$apollo.loading)?_c('div',[_c('spinner')],1):_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('categories',{attrs:{"id":_vm.eventId,"categories":_vm.categories,"permission":_vm.permission,"number-of-zones":_vm.numberOfZones}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }